/**
 * Base DTO class for Order Flight Information.
 */
export class OrderFlightInfoBaseDto {
  /** Flight code. Example: AMC113 */
  flightCode: string;

  /** Destination airport.*/
  destinationCode: string;

  /** Destination zone Id.*/
  destinationZoneId: number;
}
